import { firestore } from '@src/api/Firebase/Firebase';
import { collection } from 'firebase/firestore';
import { ShoppingCart } from '@api/ShoppingCart/ShoppingCart';
import { ShoppingCartV2 } from '@api/ShoppingCart/ShoppingCartV2';
import { SalesChannel } from '@api/SalesChannels/SalesChannel';

// Misma colección para los pedidos guardados de ambos POS. Un doc SIN
// `schemaVersion` es un carrito v1 (ShoppingCart, catálogo legacy); con
// `schemaVersion: 2` es un carrito del POS 2.0 (ShoppingCartV2, líneas
// OrderLineV2). Cada POS solo lista los suyos — retomar un carrito de la
// otra versión rompería el render/aritmética.
export interface SavedOrder {
    id?: string;
    shoppingCart: ShoppingCart | ShoppingCartV2;
    userId?: string;
    branchOfficeId?: string;
    salesChannel?: SalesChannel;
    schemaVersion?: 2;
}

export const isSavedOrderV2 = (savedOrder: SavedOrder): boolean => savedOrder?.schemaVersion === 2;

export const SAVED_ORDERS_COLLECTION = 'saved-orders';

export const savedOrdersRef = collection(firestore, SAVED_ORDERS_COLLECTION);
